export class WomanSimilarCaseUserDecision {
    markedAsNoSimilar: boolean;
}
